import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FileText, Gift, Video, Camera, Package, Truck, ChevronDown, ChevronUp } from "lucide-react";

const items = [
  { icon: FileText, text: "Sertifikat Aqiqah Resmi" },
  { icon: Gift, text: "Kambing Pilihan" },
  { icon: Video, text: "Video Penyembelihan & Live" },
  { icon: Camera, text: "Dokumentasi Foto" },
  { icon: Package, text: "Box Makanan Premium" },
  { icon: Truck, text: "Free Delivery" },
];

const WhatYouGet = () => {
  const [open, setOpen] = useState(false);

  return (
    <section className="relative py-10 md:py-20 px-6 bg-gradient-to-b from-[#FFF8F6] via-[#FFF5F2] to-[#FFF8F6] overflow-hidden">
      {/* Background */}
      <div
        className="absolute inset-0 z-0 opacity-[0.03]"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12 1L12 23M1 12L23 12' stroke='%23FF8A65' stroke-width='0.4'/%3E%3C/svg%3E")`,
        }}
      />

      <div className="relative z-10 max-w-6xl mx-auto text-center">
        {/* Title */}
        <h2 className="text-3xl md:text-5xl font-extrabold text-[#333] mb-6">
          Apa yang <span className="text-[#FF8A65]">Anda Dapatkan?</span>
        </h2>

        {/* 🟠 Mobile Dropdown */}
        <div className="block md:hidden">
          <button
            onClick={() => setOpen(!open)}
            className="flex items-center justify-center gap-2 bg-gradient-to-br from-[#FF8A65] to-[#FF6B4A] text-white px-5 py-2 rounded-full mx-auto font-semibold shadow-md hover:scale-105 transition-all"
          >
            {open ? "Tutup Detail" : "Lihat Detail"}
            {open ? <ChevronUp className="w-4 h-4" /> : <ChevronDown className="w-4 h-4" />}
          </button>

          <AnimatePresence>
            {open && (
              <motion.div
                initial={{ opacity: 0, height: 0 }}
                animate={{ opacity: 1, height: "auto" }}
                exit={{ opacity: 0, height: 0 }}
                transition={{ duration: 0.4, ease: "easeInOut" }}
                className="mt-6 grid grid-cols-2 gap-4 overflow-hidden"
              >
                {items.map((item, i) => {
                  const Icon = item.icon;
                  return (
                    <div
                      key={i}
                      className="bg-white/90 border border-[#FFD8C8]/50 rounded-2xl p-4 flex flex-col items-center text-center"
                    >
                      <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gradient-to-br from-[#FF8A65] to-[#FF6B4A] text-white mb-2 shadow">
                        <Icon className="w-6 h-6" />
                      </div>
                      <p className="text-sm font-semibold text-[#333]">{item.text}</p>
                    </div>
                  );
                })}
              </motion.div>
            )}
          </AnimatePresence>
        </div>

        {/* 🟢 Desktop Grid */}
        <div className="hidden md:grid grid-cols-6 gap-8 mt-12">
          {items.map((item, i) => {
            const Icon = item.icon;
            return (
              <div
                key={i}
                className="bg-white/90 border border-[#FFD8C8]/50 rounded-2xl p-6 flex flex-col items-center text-center shadow-sm hover:shadow-lg transition-all"
              >
                <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-gradient-to-br from-[#FF8A65] to-[#FF6B4A] text-white mb-3 shadow">
                  <Icon className="w-7 h-7" />
                </div>
                <p className="font-semibold text-sm md:text-base text-[#333]">{item.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhatYouGet;
